var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyGeneral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 125,
    viewBox: "0 0 120 125",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.847 45.9535C106.96 45.9535 108.672 44.2396 108.672 42.1255C108.672 40.0113 106.96 38.2975 104.847 38.2975C102.735 38.2975 101.023 40.0113 101.023 42.1255C101.023 44.2396 102.735 45.9535 104.847 45.9535Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25385 66.6546C4.64349 66.6546 5.77002 65.5271 5.77002 64.1362C5.77002 62.7453 4.64349 61.6178 3.25385 61.6178C1.8642 61.6178 0.737671 62.7453 0.737671 64.1362C0.737671 65.5271 1.8642 66.6546 3.25385 66.6546Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8202 111.931C16.2098 111.931 17.3364 110.804 17.3364 109.413C17.3364 108.022 16.2098 106.894 14.8202 106.894C13.4305 106.894 12.304 108.022 12.304 109.413C12.304 110.804 13.4305 111.931 14.8202 111.931Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2701 111.931L63.5791 100.867V55.5057L28.2701 66.4844V111.931Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8881 111.931L63.5791 100.867V55.5057L98.8881 66.4844V111.931Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5791 123.08L28.2701 112.016V66.6546L63.5791 77.7185V123.08Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5791 123.08L98.8881 112.016V66.6546L63.5791 77.7185V123.08Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5791 55.5057L46.978 43.0802L11.0791 55.1653L28.2701 66.4844L63.5791 55.5057Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5791 55.5057L80.1802 43.0802L116.079 55.1653L98.8881 66.4844L63.5791 55.5057Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2701 66.6546L63.5791 77.7185L45.9667 88.9525L11.0791 77.378L28.2701 66.6546Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8881 66.6546L63.5791 77.7185L81.1915 88.9525L116.079 77.378L98.8881 66.6546Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4306 11.9569C78.3772 25.3814 79.8516 28.3642 80.3355 41.5921C80.1494 44.6116 80.034 47.895 78.6104 50.5389C76.7093 54.5833 72.0593 57.3843 67.666 57.4297C63.14 57.5105 58.7029 54.7394 56.7058 50.4663C55.3007 47.873 55.3454 44.3257 57.2728 41.9712C59.3681 39.713 63.0543 39.15 65.706 40.5609C68.6229 41.9009 70.3639 44.6871 71.0088 47.6254C71.6536 50.5637 71.3703 53.7507 70.5832 56.6483C68.9369 63.6958 67.5734 64.0367 63.5361 75.9685",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4508 4.85138C79.4393 6.82536 77.6023 8.03405 75.2728 7.40376C72.82 6.98565 71.0841 6.55472 70.9723 4.79293C71.0286 2.98613 72.9999 2.27898 75.3072 1.48183C78.0738 0.382513 79.2943 2.9224 79.4508 4.85138Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6017 10.8877C64.8448 12.1674 67.4655 12.5405 68.7426 10.5859C70.1429 8.41913 71.3416 6.84388 70.0538 5.39707C68.8107 4.11744 67.601 4.97896 64.8344 6.07828C62.6167 7.20978 62.1459 9.48593 63.6017 10.8877Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3374 2.72242C70.4687 2.24026 71.8238 2.59399 72.4285 3.50708C72.6861 3.79644 72.9884 4.25299 73.078 4.58735C74.0408 6.83787 73.7381 9.06903 72.4388 9.59619C71.0163 10.3355 69.0565 9.0687 68.3064 6.94035C68.1273 6.27163 68.0377 5.93727 67.9034 5.43573C67.758 4.22047 68.2061 3.20458 69.3374 2.72242C69.5054 2.67742 69.3374 2.72242 69.3374 2.72242Z",
    fill: "#F1F3F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3374 2.72242C70.4687 2.24026 71.8238 2.59399 72.4285 3.50708C72.6861 3.79644 72.9884 4.25299 73.078 4.58735C74.0408 6.83787 73.7381 9.06903 72.4388 9.59619C71.0163 10.3355 69.0565 9.0687 68.3064 6.94035C68.1273 6.27163 68.0377 5.93727 67.9034 5.43573C67.758 4.22047 68.2061 3.20458 69.3374 2.72242ZM69.3374 2.72242C69.3374 2.72242 69.5054 2.67742 69.3374 2.72242Z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3364 38.9504H15.1463V36.7603H13.2691V38.9504H11.0791V40.8901H13.2691V43.0802H15.1463V40.8901H17.3364V38.9504Z",
    fill: "#AAB2C5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.147 93.8975H19.957V91.7075H18.0798V93.8975H15.8898V95.8373H18.0798V98.0273H19.957V95.8373H22.147V93.8975Z",
    fill: "#AAB2C5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.885 94.0215L115.205 92.6687L116.558 89.9891L114.261 88.8295L112.908 91.5091L110.229 90.1562L109.031 92.5295L111.71 93.8824L110.357 96.5619L112.654 97.7215L114.007 95.042L116.687 96.3949L117.885 94.0215Z",
    fill: "#AAB2C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGeneral);
export default __webpack_public_path__ + "static/media/empty-general.bd63f55cd42779192a2d43fa8c5e7b08.svg";
export { ForwardRef as ReactComponent };